<script setup lang="ts">
const whatsappNumber = '5541998792942'
const whatsappMessage = encodeURIComponent('Olá, vim através do site e gostaria de conversar sobre um projeto')
const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`
</script>

<template>
  <div class="fixed bottom-0 inset-x-0 z-50 container">
    <Button
      as="a"
      :href="whatsappUrl"
      size="icon-lg"
      class="
          absolute
          right-4 bottom-[calc(100%+1rem)]
          lg:right-8 lg:bottom-[calc(100%+2rem)]
          bg-secondary hover:bg-secondary/90
          text-white cursor-pointer
          rounded-full size-16
          shadow-lg hover:shadow-xl
          transition-all duration-200
          hover:scale-110
          group z-100
        "
      aria-label="Entrar em contato via WhatsApp"
    >
      <Icon
        name="ph:whatsapp-logo-light"
        class="text-3xl group-hover:scale-110 transition-transform duration-200 mb-0.5 ml-0.5"
      />
      <div class="absolute inset-0 rounded-full bg-secondary/90 animate-ping opacity-10" />
    </Button>
  </div>
</template>
